import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import purchaseInfoReducer from './reducers';

const rootReducer = combineReducers({
  purchaseInfo: purchaseInfoReducer,
  storeNo: purchaseInfoReducer, // storeNo도 같은 리듀서 사용
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer as any);

export const store = createStore(persistedReducer as any);
export const persistor = persistStore(store);
export default store;
